import axiosInstanceApiGateway from 'config/apiServiceApiGateway'

export type GetConversionTaskParamsType = {
  page_size: number
  page_index: number
  status?: string
  location_id?: number
  order_number?: string
}

export type ConversionTaskProductType = {
  id: string
  product_id: string
  product_name: string
  product_sku: string
  product_uom: string
  quantity: number
}

export type ConversionTaskStaffType = {
  id: string
  name: string
}

export type ConversionTaskLocationType = {
  id: string
  name: string
  type: string
}

export type ConversionTaskItemType = {
  id: string
  order_number: string
  invoice_reference: string
  status: string
  product_destinations: ConversionTaskProductType[]
  quantity: number
  created_at: string
  created_by: string
  manufacturing_rule_id: string
  creation_mode: string
  staff: ConversionTaskStaffType
  location: ConversionTaskLocationType
  note: string
  updated_at: string
  updated_by: string
}

export type ConversionTaskDetailType = ConversionTaskItemType & {
  product_origins: ConversionTaskProductType[]
}

export type GetConversionTaskResponseType = {
  data: ConversionTaskItemType[]
  pagination: {
    sort: string
    direction: string
    page_size: string
    page_index: string
  }
}

export type GetConversionTaskDetailResponseType = {
  data: ConversionTaskDetailType
}

export type GetStaffSorterByLocationKongResponseType = {
  staff_id: number
  staff_full_name: string
}

export type GetPicListResponseType = {
  staff_id: number
  staff_full_name: string
}

export type CreateConversionTaskPayloadType = {
  manufacturing_rule_id: number
  location_id: number
  quantity: number
  reference?: string
}

type AssignPicConversionTaskPayloadType = {
  staff_id: number
}

type PostPutResponseType = {
  message: string
}

export const getConversionTask = (params: GetConversionTaskParamsType) =>
  axiosInstanceApiGateway.Get<GetConversionTaskResponseType, true>({
    url: '/wims/internal/v1/manufacturing-orders',
    params,
    config: { paramsSerializer: { indexes: null } },
  })

export const getConversionTaskDetail = (id: number) =>
  axiosInstanceApiGateway.Get<GetConversionTaskDetailResponseType, true>({
    url: `/wims/internal/v1/manufacturing-orders/${id}`,
  })

export const cancelConversionTask = (id: number) =>
  axiosInstanceApiGateway.Post<PostPutResponseType, true>({
    url: `/wims/internal/v1/manufacturing-orders/${id}:cancel`,
  })

export const postCreateConversionTask = (data: CreateConversionTaskPayloadType) =>
  axiosInstanceApiGateway.Post<PostPutResponseType, true>({
    url: '/wims/internal/v1/manufacturing-orders',
    data,
  })

export const getPicList = (locationId: number, roleName: string) =>
  axiosInstanceApiGateway.Post<{ data: GetPicListResponseType[] }, true>({
    url: `/staff-management/internal/v1/staff/get-by-role`,
    data: {
      role_name: roleName,
      location_id: locationId,
      is_active_role_only: true,
    },
  })

export const postAssignPicConversionTask = (id: number, data: AssignPicConversionTaskPayloadType) =>
  axiosInstanceApiGateway.Post<PostPutResponseType>({
    url: `/wims/internal/v1/manufacturing-orders/${id}:assign`,
    data,
  })

export const postCompleteConversionTask = (id: number) =>
  axiosInstanceApiGateway.Post<PostPutResponseType>({
    url: `/wims/internal/v1/manufacturing-orders/${id}:complete`,
  })
